import React, { Component } from 'react'
import Header from '../../Components/header/index.jsx'
import Footer from '../../Components/Footer/index'
import { useParams } from 'react-router-dom'
import './index.scss'
import { ArrowRightOutlined } from '@ant-design/icons'
class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|荣誉资质'
  }
  render() {
    return (
      <div>
        <Header></Header>
        <div className="hezuoContent">
          <div className="hezuoContent-title">
            <div className="hezuoContent-title-h1">荣誉资质</div>
            <div className="hezuoContent-title-text">HONORARY</div>
          </div>
          <div className="hezuoContent-details">
            <div className="hezuoContent-details-item">
              <div className="hezuoContent-details-item-title">2015+</div>
              <div className="hezuoContent-details-item-test">成立时间</div>
            </div>
            <div className="hezuoContent-details-item">
              <div className="hezuoContent-details-item-title">20+</div>
              <div className="hezuoContent-details-item-test">产品认证</div>
            </div>
            <div className="hezuoContent-details-item">
              <div className="hezuoContent-details-item-title">50+</div>
              <div className="hezuoContent-details-item-test">落地项目</div>
            </div>
            <div className="hezuoContent-details-item">
              <div className="hezuoContent-details-item-title">20+</div>
              <div className="hezuoContent-details-item-test">技术专家</div>
            </div>
          </div>
        </div>
        <div style={{ height: '1.485714rem ' }}></div>
        <div className="hezuo-details">
          <div className="hezuo-details-title">
            <div className="hezuo-details-title-h1">
              企业资质
              <div className="hezuo-details-title-h1-border"></div>
            </div>
          </div>
          <div className="hezuo-details-img">
            <div className="hezuo-details-img-item" style={{ marginRight: '0.8rem' }}>
              <img className="hezuo-details-img-item-img" src={require('../../image/left1.png')} alt="" />
              <img className="hezuo-details-img-item-img" src={require('../../image/RKZZ-202403002锐控中关村高新技术企业_00.png')} alt="" />
            </div>
            <div className="hezuo-details-img-item">
              <img className="hezuo-details-img-item" src={require('../../image/RKZZ-202403022国军标质量管理体系认证及CNAS质量管理体系认证_00.png')} alt="" />
            </div>
          </div>
          <div className="hezuo-details-img">
            <div className="hezuo-details-img-item" style={{ marginRight: '0.8rem' }}>
              <img className="hezuo-details-img-item-img" src={require('../../image/RKZZ-202403023北京市“创新型”中小企业证书_00.png')} alt="" />
              <img className="hezuo-details-img-item-img" src={require('../../image/left2.png')} alt="" />
            </div>
            <div className="hezuo-details-img-item">
              <img className="hezuo-details-img-item" src={require('../../image/RKZZ-202403022国军标质量管理体系认证及CNAS质量管理体系认证_01.png')} alt="" />
            </div>
          </div>
          <div className="hezuo-details-content" style={{textIndent: '2em'}}>北京锐控自动化科技有限公司聚焦产业互联网，助力企业和政府进行数字化转型，在数字生活、数字城市、数字能源、工业互联网等领域，以B2B、B2C的模式赋能产业升级、提升用户体验，创造新价值、分享新价值。近年来公司软件著作数量也在不断提升，软件成果不仅提升了公司产品科技含量，提高企业核心竞争力，且为公司的再发展提供了强有力的科技支撑。2021年，北京锐控正式宣布“锐控生态伙伴”计划，与行业顶尖的伙伴企业一起，为客户提供更稳妥、高效、动态升级的服务能力。2022年，公司被认定为北京市知识产权试点单位，并荣获国家高新技术企业和中关村高新技术企业称号，同时通过了国军标质量管理体系认证及CNAS质量管理体系认证，并在2024年取得北京市“创新型”中小企业荣誉称号，标志着我公司在创新发展的道路上又迈出了坚实的一步。</div>
        </div>
        <div className="hezuo-details" style={{ paddingTop: '2.285714rem ' }}>
          <div className="hezuo-details-title">
            <div className="hezuo-details-title-h1">
              技术团队
              <div className="hezuo-details-title-h1-border"></div>
            </div>
          </div>
          <div className="hezuo-details-imagebox">
            <img className="hezuo-details-imagebox-img" src={require('../../image/技术1.png')} alt="" />
            <img className="hezuo-details-imagebox-img" src={require('../../image/技术2.png')} alt="" />
            <img className="hezuo-details-imagebox-img" src={require('../../image/技术3.png')} alt="" />
          </div>
          <div className="hezuo-details-content" style={{textIndent: '2em'}}>北京锐控拥有一支由计算机软件专家和行业应用专家共同组成的一流的科研队伍。其中有三位博士员工入选“通州区高层次人才发展支持计划”顶尖人才，同时被聘为“通州区特聘专家”，每年享受通州政府科研专项津贴。公司研究生以上学历员工占总人数的50%以上，同时我们联合哈尔滨理工大学测控技术与通信工程学院和哈尔滨工业大学计算机学院多智能体机器人研究中心成立了专家委员会，联合北京本地众多科技公司形成生态圈，共同研究技术，分享经验成果。</div>
        </div>
        <Footer></Footer>
      </div>
    )
  }
}

export default index
